import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'react-datepicker/dist/react-datepicker.css';
import App from './App.jsx';
import './styles.css';
import './styles/responsive.css';
import './styles/mobile.css';
import AuthProvider from './context/AuthContext.jsx';
import MessageProvider from './context/MessageContext.jsx';
import OrganizationSettingsProvider from './context/OrganizationSettingsContext.jsx';
import SuperAdminAuthProvider from './context/SuperAdminAuthContext.jsx';
import { CompanyProvider } from './context/CompanyContext.jsx';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <MessageProvider>
          <OrganizationSettingsProvider>
            <CompanyProvider>
              <SuperAdminAuthProvider>
                <App />
              </SuperAdminAuthProvider>
            </CompanyProvider>
          </OrganizationSettingsProvider>
        </MessageProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
)
